import {
  Component,
  Inject,
  Input,
  OnInit
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

import { UIRouter } from '@uirouter/core';

import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { CompanyService }           from '../companies/company.service';
import { LaborProductModel }        from '../products/models/labor-product';
import { MessagesService }          from '../messages/messages.service';
import { PartstechService }         from './partstech.service';
import { QuoteModel }               from '../core/models/quote';

@Component({
  selector   : 'wor-partstech-labor-settings',
  template: require('./partstech.labor-settings.component.html')
})
export class PartstechLaborSettingsComponent implements OnInit {
  private areCredentialsSet = false;

  public quote : QuoteModel = {
    period           : '',
    total_quoted_cost: ''
  };

  @Input() integrations: CompanyIntegrationsModel;

  constructor (
    private translateService: TranslateService,
    private companyService  : CompanyService,
    private messagesService : MessagesService,
    private partstechService: PartstechService,
    private router          : UIRouter
  ) {}

  ngOnInit () : void {
    this.areCredentialsSet = this.partstechService.areCredentialsSet(this.integrations);

    this.getLaborQuote();
  }

  activate () : void {
    this.partstechService.activateLabor()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {
        name: 'Partstech labour Time'
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  deactivate () : void {
    this.partstechService.deactivateLabor()
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.INTEGRATIONS.DEACTIVATED', {
        name: 'Partstech labour Time'
      }), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  getLaborQuote () : void {
    this.partstechService.getLaborQuote()
    .then(( quote : QuoteModel ) => {
      this.quote = quote;
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }

  handleProductSelection ( product : LaborProductModel, key : string ) : void {
    this.integrations[ `partstech_${ key }_product_id` ]   = product.id;
    this.integrations[ `partstech_${ key }_product_name` ] = product.item_code;
  }

  isActivated () : boolean {
    return this.companyService.hasIntegration('partstech-labor')
      && (
        this.companyService.hasIntegration('partstech')
        && this.areCredentialsSet
      );
  }

  isDeactivatedButAvailable () : boolean {
    return !this.companyService.hasIntegration('partstech-labor')
      && (
        this.companyService.hasIntegration('partstech')
        && this.areCredentialsSet
      );
  }

  save () : void {
    this.partstechService.save(this.integrations)
    .then(() => {
      this.messagesService.show(this.translateService.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');

      this.router.stateService.reload();
    })
    .catch(err => {
      this.messagesService.error(err);
    });
  }
}
